import React, { useState } from 'react';
import {
    TextField,
    Select,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Box,
    Typography
} from '@mui/material';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { RoleListAPI } from '../../Conections/RolesAndPermissionsConection';
import { CreateUser, can } from '../../Conections/LogConections';
import ErrorCard from '../../Conections/ErrorCard';


function UserRegistrationForm() {

    const auth = useAuth();
    const goTo = useNavigate();

    const [email, setEmail] = useState('');
    const [roleId, setRoleId] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [permitido, setPermitido] = React.useState(false);
    const [errorResponse, setErrorResponse] = useState("");
    const [messageResponse, setMessageResponse] = useState("");
    const [roles, setRoles] = useState([{ id: 0, name: "" }]);

    React.useEffect(() => {
        reloaduser();
    }, []);

    async function reloaduser() {
        if (auth.getToken()) {
            const permisionCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/createuser");
            if (permisionCan) {
                setPermitido(true);
                const datos = await RoleListAPI(auth.getToken(), auth.getCompany());
                setRoles(datos);
            } else {
                setPermitido(false);
            }
        }
        else {
            goTo("/login");
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        var errors = 0;
        try {
            if (email === "") {
                setErrorResponse("Name can not be empty");
                errors++;
            }
            if (roleId === "") {
                setErrorResponse("Address name can not be empty");
                errors++;
            }
            if (errors === 0) {
                setErrorResponse("");
                const response = await CreateUser(email, roleId, auth.getToken(), auth.getCompany());
                console.log(response);
                if (response && typeof response == "number") {
                    setMessageResponse("Usuario registrado");
                }
                else {
                    setMessageResponse("");
                    setErrorResponse("No se pudo registrar el usuario");
                }
                // goTo("/dashboard");
            }
        } catch (error) {
            setErrorResponse("System Error");
        }
    };

    if (submitted) {
        return (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Typography variant="h6">¡Registro exitoso!</Typography>
                <Button
                    variant="contained"
                    onClick={() => {
                        setEmail('');
                        setRoleId('');
                        setSubmitted(false);
                    }}
                    sx={{ mt: 2 }}
                >
                    Registrar otro usuario
                </Button>
            </Box>
        );
    }

    return (
        permitido ? (
            <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Registro de Usuario
                </Typography>
                {!!errorResponse && <div className="errorMessage">{errorResponse}</div>}
                {!!messageResponse && <><br></br><div className="successMessage">{messageResponse}</div><br></br></>}
                <TextField
                    label="Email"
                    type="email"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <FormControl fullWidth margin="normal">
                    <InputLabel id="role-select-label">Rol</InputLabel>
                    <Select
                        labelId="role-select-label"
                        value={roleId}
                        label="Rol"
                        onChange={(e) => setRoleId(e.target.value)}
                        required
                    >
                        {roles.map((role) => (
                            <MenuItem key={role.id} value={role.id}>
                                {role.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                    Registrar
                </Button>
            </Box>
        ) : (
            <ErrorCard />
        )
    );
}

export default UserRegistrationForm;